import {
  ActionButton,
  Dropdown,
  IDropdownOption,
  IIconProps,
  Label,
  TextField,
} from '@fluentui/react';
import React, { useContext, useEffect, useRef } from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useDebouncedCallback from 'use-debounce/lib/useDebouncedCallback';
import {
  GetVPFilterDropdownData,
  readVPPBSTaxonomyData,
  saveVPStateAttr,
} from '../../../reducers/visualPlanReducer';
import CustomDatePicker from '../../../shared/customDatePicker/customDatePicker';
// import 'style.css';
import { ViewMode } from '../../../shared/ganttv2';
import {
  calculateEndDate, calculateStartDate,
  formatDateTimeToISOString,
  getSelectedFilterDates,
  updateVPProductStatusFilter,
  updateVPStandardFilter,
} from '../../../shared/util';
import { ViewModeContext } from './component';
import ModeSwitcherWithRadioButtons from '../../../shared/ganttViewSwitcher/viewSwitcherWithRadioButtons';
import moment from 'moment';

export const ViewSwitcher: (props: { onViewSwitcherFilterValueChange: any }) => JSX.Element = (props:{ onViewSwitcherFilterValueChange: any}) => {
  const [startDate, setStartDate] = React.useState<Date | null>(null);
  // const [isProjectSelected, setIsProjectSeleted] = React.useState<boolean>(true);
  const [searchTriggered, setSearchTriggered] = React.useState<boolean>(false);
  const [endDate, setEndDate] = React.useState<Date | null>(null);
  const [selectedMode, setSelectedViewMode] = React.useState<ViewMode>(
    ViewMode.QuaterYear
  );
  const formRef: any = useRef();
  const [standardFilterKey, setStandardFilterKey] = React.useState<any>('5'); // Initially set to Project
  const [prodStatusFilterKey, setProdStatusFilterKey] =
    React.useState<any>('1');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { onViewModeChange, onViewListChange, isCheck } =
    useContext(ViewModeContext);

  const standerdFilterOptions = useSelector((state: any) =>
    updateVPStandardFilter(state.vp.vpFilterDropdown)
  );

  const addFriendIcon: IIconProps = { iconName: 'Refresh' };

  const productStatusFilterOptions = useSelector((state: any) =>
    updateVPProductStatusFilter(state.projectBreakdown?.productStates)
  );

  useEffect(() => {
    dispatch(GetVPFilterDropdownData());
  }, []);

  const debounced = useDebouncedCallback(
    (value: any) => {
      if (value) {
        dispatch(
          readVPPBSTaxonomyData({
            fromDate: formatDateTimeToISOString(startDate!!),
            toDate: formatDateTimeToISOString(endDate!!),
            title: value,
          })
        );
      } else {
        dispatch(
          readVPPBSTaxonomyData({
            fromDate: formatDateTimeToISOString(startDate!!),
            toDate: formatDateTimeToISOString(endDate!!),
            title: null,
          })
        );
      }
    },
    // delay in ms
    1000
  );

  const resetViewSwitcher = () => {
    setStartDate(null);
    setEndDate(null);
    setStandardFilterKey('5');
    setProdStatusFilterKey('1');
    formRef.current.reset();
    formRef.current.mutators.setSearchString(null);
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        height: 70,
        width: '100%',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        borderBottom: '0.5px solid gray',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white',
          flexGrow: 0.2,
          width: '100%',
        }}
      >
        <Form
          onSubmit={() => {}}
          initialValues={{
            startDate: startDate ? startDate : null,
            endDate: endDate ? endDate : null,
          }}
          mutators={{
            setHeaderDocs: (args, state, utils) => {
              const field = state.fields['header.files'];
              field.change(args[0]);
            },
            setSearchString: (args, state, utils) => {
              const field = state.fields['searchString'];
              field.change(args[0]);
            },
            setDateRange: (args, state, utils) => {
              const from = state.fields['startDate'];
              const to = state.fields['endDate'];
              from.change(getSelectedFilterDates(args)[0]);
              to.change(getSelectedFilterDates(args)[1]);
              dispatch(
                saveVPStateAttr(
                  'scrollPosDate',
                  getSelectedFilterDates(args)[0]
                )
              );

              dispatch(
                readVPPBSTaxonomyData({
                  fromDate: formatDateTimeToISOString(
                    getSelectedFilterDates(args)[0]
                  ),
                  toDate: formatDateTimeToISOString(
                    getSelectedFilterDates(args)[1]
                  ),
                  filter: args[0],
                  productStatus:
                    prodStatusFilterKey == 1 ? null : prodStatusFilterKey,
                })
              );
            },
          }}
          // validate={ validate }
          render={({ handleSubmit, form, submitting, pristine, values }) => {
            // props.submit(handleSubmit);
            formRef.current = form;
            props.onViewSwitcherFilterValueChange(values);
            return (
              <form onSubmit={handleSubmit} noValidate>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                    height: 70,
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      flex: 1,
                      height: 70,
                      width: '100%',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flex: 1,
                        height: 70,
                        width: '100%',
                      }}
                    >
                      <div
                        style={{
                          width: 180,
                          marginLeft: 15,
                          marginRight: 15,
                          marginTop: 30,
                        }}
                      >
                        <div style={{ width: 180, marginLeft: 15 }}>
                          <Field name="searchString">
                            {({ input, meta }) => (
                              <TextField
                                value={values.searchString}
                                placeholder={t('search')}
                                onChange={(event, value) => {
                                  if (value?.length!! >= 1) {
                                    input.onChange(value);
                                  } else {
                                    input.onChange(null);
                                  }
                                  if (value?.length!! >= 3) {
                                    setSearchTriggered(true);
                                    debounced(value);
                                    //handleTreeOnSearch(value);
                                  } else if (
                                    value?.length!! === 0 &&
                                    searchTriggered
                                  ) {
                                    setSearchTriggered(false);
                                    debounced(null);
                                    //handleTreeOnSearch('');
                                  }
                                }}
                              />
                            )}
                          </Field>
                        </div>
                      </div>

                      <div style={{ width: 180, marginLeft: 20 }}>
                        <Field name="productStatus">
                          {({ input, meta }) => (
                            <Dropdown
                              placeholder={t('productStatus')}
                              label={t('productStatus')}
                              selectedKey={prodStatusFilterKey}
                              // eslint-disable-next-line react/jsx-no-bind
                              onChange={(
                                event: React.FormEvent<HTMLDivElement>,
                                item: IDropdownOption | undefined
                              ) => {
                                if (item) {
                                  setProdStatusFilterKey(item.key);
                                  input.onChange(
                                    dispatch(
                                      readVPPBSTaxonomyData({
                                        title: values.searchString,
                                        fromDate: values.date
                                          ? formatDateTimeToISOString(
                                              getSelectedFilterDates(
                                                values.date
                                              )[0]
                                            )
                                          : null,
                                        toDate: values.date
                                          ? formatDateTimeToISOString(
                                              getSelectedFilterDates(
                                                values.date
                                              )[1]
                                            )
                                          : null,
                                        productStatus:
                                          item.key == 1 ? null : item.key,
                                      })
                                    )
                                  );
                                  input.onChange(item.key);
                                }
                              }}
                              options={productStatusFilterOptions}
                            />
                          )}
                        </Field>
                      </div>

                      <div style={{ width: 180, marginLeft: 15 }}>
                        <Field name="date">
                          {({ input, meta }) => (
                            <Dropdown
                              placeholder={t('standardFilter')}
                              label={t('standardFilter')}
                              // selectedKey={values.date ? values.date : '5'}
                              selectedKey={standardFilterKey}
                              // eslint-disable-next-line react/jsx-no-bind
                              onChange={(event, value: any) => {
                                let date = null;
                                if (value) {
                                  date = value.key;
                                  input.onChange(value.key);
                                  setStandardFilterKey(value.key);
                                } else {
                                  date = null;
                                  input.onChange(null);
                                }
                                form.mutators.setDateRange(value?.key);
                                if (value?.key === '5') {
                                  onViewModeChange(ViewMode.QuaterYear);
                                  // setIsProjectSeleted(true)
                                  setSelectedViewMode(ViewMode.QuaterYear);
                                } else {
                                  onViewModeChange(ViewMode.Week);
                                  // setIsProjectSeleted(false)
                                  setSelectedViewMode(ViewMode.Week);
                                }
                              }}
                              options={
                                standerdFilterOptions
                                  ? standerdFilterOptions
                                  : []
                              }
                            />
                          )}
                        </Field>
                      </div>

                      <div
                        className={'vpDatePicker180'}
                        style={{ width: 180, marginLeft: 15 }}
                      >
                        <Label style={{ width: 180 }}>{t('fromDate')}:</Label>
                        <Field name="startDate">
                          {({ input, meta }) => (
                            <CustomDatePicker
                              setValue={values.startDate}
                              getValue={(date: Date) => {
                                setStandardFilterKey('8');
                                input.onChange(date);
                                setStartDate(date);
                                input.onChange(date);
                                const newDate = calculateEndDate(selectedMode, date);
                                setEndDate(newDate);

                                dispatch(
                                  readVPPBSTaxonomyData({
                                    fromDate: formatDateTimeToISOString(date),
                                    toDate: formatDateTimeToISOString(newDate),
                                    productStatus:
                                      prodStatusFilterKey == 1
                                        ? null
                                        : prodStatusFilterKey,
                                  })
                                );
                              }}
                            />
                          )}
                        </Field>
                      </div>
                      <div
                        className={'vpDatePicker180'}
                        style={{ width: 180, marginLeft: 15 }}
                      >
                        <Label style={{ width: 180 }}>{t('toDate')}:</Label>
                        <Field name="endDate">
                          {({ input, meta }) => (
                            <CustomDatePicker
                              setMinDate={
                                startDate
                                  ? startDate
                                  : new Date(
                                      form.getFieldState('startDate')?.value
                                    )
                              }
                              setValue={values.endDate}
                              getValue={(date: Date) => {
                                setStandardFilterKey('8');
                                input.onChange(date);
                                const newDate = calculateStartDate(selectedMode, date);
                                setStartDate(newDate);
                                setEndDate(date);
                                dispatch(
                                  readVPPBSTaxonomyData({
                                    fromDate: formatDateTimeToISOString(newDate),
                                    toDate: formatDateTimeToISOString(date),
                                    productStatus:
                                      prodStatusFilterKey == 1
                                        ? null
                                        : prodStatusFilterKey,
                                  })
                                );
                              }}
                            />
                          )}
                        </Field>
                      </div>

                      <ModeSwitcherWithRadioButtons
                        onViewModeChange={(t: any) => {
                          onViewModeChange(t);
                          setSelectedViewMode(t);
                        }}
                        onViewListChange={onViewListChange}
                        isCheck={isCheck}
                        selectedViewMode={selectedMode}
                      />

                      <ActionButton
                        onClick={() => {
                          resetViewSwitcher();
                          dispatch(
                            readVPPBSTaxonomyData({
                              fromDate: formatDateTimeToISOString(startDate!!),
                              toDate: formatDateTimeToISOString(endDate!!),
                              productStatus:
                                prodStatusFilterKey == 1
                                  ? null
                                  : prodStatusFilterKey,
                            })
                          );
                        }}
                        iconProps={addFriendIcon}
                        allowDisabledFocus
                        disabled={false}
                        checked={false}
                        style={{ marginTop: 15 }}
                      >
                        {t('refresh')}
                      </ActionButton>
                    </div>
                  </div>
                </div>

                 {/*<pre>{ JSON.stringify(values, null, 2) }</pre>*/}
              </form>
            );
          }}
        />
      </div>
    </div>
  );
};
